import React from "react";
import { getAllCountriesApi } from "../../../Services/apiCalls";
import loadingIcon from "../../../Assests/Images/loading.gif";
import htmlIcon from "../../../Assests/Images/htmlIcon.png";
import { CustomInput } from "../../../components";
import { ENGLISH_LANGUAGE_ID } from "./translationList";

class SystemLabelsList extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      loadingId,
      onFormFieldChange,
      onFormFieldBlur,
      currentWorkplace,
      SystemLabelsList,
      handleSystemLabelChange,
      HandlHTMLEditor,
      onOpenTranslations,
      listLanguage,
      labels,
    } = this.props;
    // English is shown as a reference while another language is being edited.
    const showEnglish = listLanguage && listLanguage.value !== ENGLISH_LANGUAGE_ID;

    return (
      <div
        className="system_labels_list"
        test-data-id={"systemlabels-list-item"}
      >
        {SystemLabelsList && SystemLabelsList.length > 0 ? (
          <div>
            {SystemLabelsList.map((item, i) => {
              return (
                <div
                  className="input-field"
                  test-data-id={"systemlabels-list-item"}
                  key={i}
                >
                  <h6>
                    {item.Identifier}
                    {item.IsTranslated === false ? (
                      <span className="label-missing">
                        {labels.ADMIN_SYSTEM_LABEL_MISSING || "Missing"}
                      </span>
                    ) : (
                      ""
                    )}
                  </h6>
                  {showEnglish ? (
                    <p className="label-english" title="English">
                      {item.EnglishMessage || "-"}
                    </p>
                  ) : (
                    ""
                  )}
                  <div className="labelsListItem">
                    <input
                      name="systemLabels"
                      type="text"
                      value={item.Message || ""}
                      placeholder={
                        item.IsTranslated === false
                          ? `${listLanguage ? listLanguage.label : ""} text`
                          : ""
                      }
                      onBlur={(e) => onFormFieldBlur(e, { param: item })}
                      test-data-id={"systemlabels-list-input"}
                      onChange={(e) =>
                        handleSystemLabelChange(e, { param: item })
                      }
                    />
                    {loadingId == item.SystemLabelId ? (
                      <img src={loadingIcon}></img>
                    ) : (
                      <img
                        src={htmlIcon}
                        onClick={(e) => HandlHTMLEditor(e, { param: item })}
                      ></img>
                    )}
                    <button
                      type="button"
                      className="label-translations-btn"
                      title={
                        labels.ADMIN_SYSTEM_LABEL_TRANSLATIONS ||
                        "All languages"
                      }
                      test-data-id={"systemlabels-translations-btn"}
                      onClick={() => onOpenTranslations(item)}
                    >
                      {labels.ADMIN_SYSTEM_LABEL_LANGUAGES_SHORT || "Languages"}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="no-item-label">
            <label>{labels.ADMIN_NO_ITEM_TO_DISPLAY}</label>
          </div>
        )}
      </div>
    );
  }
}

export default SystemLabelsList;
